import { useSelector } from "react-redux";
import { useMemo } from "react";
import trans from "../utils";

/**
 * Hook to get all available dashboards based on user permissions
 * @returns {Array} Array of dashboard objects with {key, label, path, component, moduleKey}
 */
const useAvailableDashboards = () => {
  const user = useSelector((state) => state.users.auth);
  const permissions = user?.permissions || [];

  const dashboardConfig = useMemo(() => [
    {
      key: "dashboard",
      label: trans("Tracking Dashboard"),
      path: "/dashboard",
      moduleKeys: ["DASHBOARD"], // Support multiple module key variations
      component: "Dashboard",
    },
    {
      key: "fsmDashboard",
      label: trans("FSM Dashboard"),
      path: "/dashboard/fsm",
      moduleKeys: ["FSMDASHBOARD", "DASHBOARDFS"], // Support both variations
      component: "FSMDashboard",
    },
    // {
    //   key: "consultantDashboard",
    //   label: trans("Consultant Dashboard"),
    //   path: "/dashboard/consultant",
    //   moduleKeys: ["DASHBOARDQAQC"],
    //   component: "ConsultantDashboard",
    // },
    {
      key: "qaDashboard",
      label: trans("QA Dashboard"),
      path: "/dashboard/qa",
      moduleKeys: ["DASHBOARDQAQC"],
      component: "DASHBOARDQAQC",
    },
  ], []);

  // Filter dashboards based on user permissions
  const availableDashboards = useMemo(() => {
    return dashboardConfig.filter((dashboard) => {
      const hasPermission = permissions.some(
        (perm) =>
          dashboard.moduleKeys.includes(perm.moduleKey) &&
          perm.actions?.view === true,
      );
      return hasPermission;
    });
  }, [dashboardConfig, permissions]);

  return availableDashboards;
};

export default useAvailableDashboards;
